import './style.scss';
import { Box, Grid, Typography } from "@mui/material";
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import DefaultConstants from '../../../../data/Constants';


const Sustainability = (props) => {
    const { translate, currentLanguage } = useLanguageContext();

    return <Grid container id='sustainability-section' paddingBottom={8}>
        <Grid item xs={12} className='grid-content-section padding-none'>
            <Box className='wallpaper small' sx={{ backgroundImage: `url(${DefaultConstants.sustainability.wallpaper})` }}>
                <Typography className='wallpaper-title'>
                    {translate(DefaultConstants.sustainability.title)}
                </Typography>

                <Typography className='wallpaper-subtitle'>
                    {translate(DefaultConstants.sustainability.subtitle)}
                </Typography>
            </Box>
        </Grid>

        <Grid item md={12} xs={12} className='grid-content-section display-flex flexdirection-column alignitems-center justifycontent-center gap-12'>
            {
                DefaultConstants.sustainability.images[currentLanguage.value].map((i, index) => {
                    return <img src={i} alt={`sustainability-${index}`} key={index} />;
                })
            }
        </Grid>

        <Grid item xs={12} className='grid-content-section textalign-center' paddingX={2}>
            <video controls>
                <source src={DefaultConstants.sustainability.video} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </Grid>
    </Grid>;
}


export default Sustainability;